import React from "react";
import { RWebShare } from "react-web-share";
import share from "../Assets/Images/share.png";

export const WebShare = ({ url, title }) => {
  
  return (
    <RWebShare
      data={{
        text: `${title + " " + url}`,
        url: url,
        title: "Share on Social media",
      }}
      onClick={() => console.log("shared successfully!", url)}
    >
      <button
        onClick={(e) => {e.preventDefault()}}
        style={{
          background: "#0000",
          border: "0",
        }}
        title="share link"
      >
        <img  loading="lazy"  width="" height=""  
          src={share}
          className="w-100"
          alt="share"
        />
      </button>
    </RWebShare>
  );
};
